import UserRole from "../../../../../common/types/user-role";
import UserPermissionsDefinition from "../../../../../common/utils/user/permissions/user-permissions-definition";

export type OrderActiveListingUserPermissionOption =
  | "hasVisibleOrderAddLink"
  | "hasVisiblePlannerLink"
  | "hasVisibleOrderJoinButton"
  | "hasVisibleToOrderPlanningButton"
  | "hasVisibleOptitoolButton"
  | "hasAccessToFleetPartnerColumn"
  | "hasAccessToStartingPointsMap";

export type OrderActiveListingUserPermissionsDefinition =
  UserPermissionsDefinition<OrderActiveListingUserPermissionOption>;

const orderActiveListingUserPermissionDefinition: OrderActiveListingUserPermissionsDefinition =
  {
    hasVisibleOrderAddLink: [
      UserRole.ADMIN,
      UserRole.DISPATCHER,
      UserRole.OPERATOR,
    ],
    hasVisiblePlannerLink: [],
    hasVisibleOrderJoinButton: [UserRole.ADMIN, UserRole.OPERATOR],
    hasVisibleToOrderPlanningButton: [UserRole.ADMIN],
    hasVisibleOptitoolButton: [
      UserRole.ADMIN,
      UserRole.OPERATOR,
      UserRole.DISPATCHER,
    ],
    hasAccessToFleetPartnerColumn: [
      UserRole.ADMIN,
      UserRole.RAILY_OFFICER,
      UserRole.OPERATOR,
    ],
    hasAccessToStartingPointsMap: [
      UserRole.ADMIN,
      UserRole.RAILY_OFFICER,
      UserRole.OPERATOR,
    ],
  };

export default orderActiveListingUserPermissionDefinition;
